import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles(() => ({
  footer: {
    color: "#455a64",
  },
}));
